import { Navigate, Outlet, RouteObject } from 'react-router-dom';

import { ArcadeProvider } from './context/Arcade';

export const arcadeRoutes: RouteObject[] = [
  {
    path: 'arcade/*',
    children: [
      { index: true, element: <Navigate to="arcade" /> },
      { path: 'login/:token', lazy: () => import('arcade/pages/login/Login').then(m => ({ Component: m.Login })) },
      {
        path: ':teamSlug',
        index: true,
        lazy: () => import('arcade/pages/welcome/Welcome').then(m => ({ Component: m.Welcome })),
      },
      {
        path: ':teamSlug/*',
        element: (
          <ArcadeProvider>
            <Outlet />
          </ArcadeProvider>
        ),
        children: [
          {
            path: 'leaderboards',
            lazy: () => import('arcade/pages/leaderboards/Leaderboards').then(m => ({ Component: m.Leaderboards })),
          },
          {
            path: 'tv-leaderboards',
            lazy: () =>
              import('arcade/pages/tvleaderboards/TVLeaderboards').then(m => ({ Component: m.TVLeaderboards })),
          },
          {
            path: 'tracks',
            lazy: () => import('arcade/pages/select-track/SelectTrack').then(m => ({ Component: m.SelectTrack })),
          },
          {
            path: 'tracks/:trackID',
            children: [
              {
                path: 'input',
                lazy: () =>
                  import('arcade/pages/hiscore-input/HiscoreInput').then(m => ({ Component: m.HiscoreInput })),
              },
              {
                path: 'leaderboard',
                lazy: () => import('arcade/pages/leaderboard/Leaderboard').then(m => ({ Component: m.Leaderboard })),
              },
              {
                path: 'challenges/:challengeID',
                children: [
                  {
                    path: 'difficulty',
                    lazy: () =>
                      import('arcade/pages/select-difficulty/SelectDifficulty').then(m => ({
                        Component: m.SelectDifficulty,
                      })),
                  },
                  { path: 'rules', lazy: () => import('arcade/pages/rules/Rules').then(m => ({ Component: m.Rules })) },
                  {
                    path: 'notes',
                    lazy: () => import('arcade/pages/challenge/Challenge').then(m => ({ Component: m.Challenge })),
                  },
                  {
                    path: 'assignment',
                    lazy: () => import('arcade/pages/assignment/Assignment').then(m => ({ Component: m.Assignment })),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
